import { __awaiter } from "tslib";
import log from 'pathfinder/utils/log';
const getDateFromUtcEpoch = (utcEpoch) => {
    const date = new Date(0);
    return date.setUTCSeconds(utcEpoch);
};
const sortDescByLatestContributionTimestamp = (first, second) => {
    const firstTimestamp = first.creationDate ? getDateFromUtcEpoch(first.creationDate.epochSecond) : 0;
    const secondTimestamp = second.creationDate ? getDateFromUtcEpoch(second.creationDate.epochSecond) : 0;
    return secondTimestamp - firstTimestamp;
};
export default function getDiscussionThread() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const currentPage = (yield window.SilverSurferSDK.getContext()).current;
            if (!currentPage) {
                return null;
            }
            const productId = currentPage.productId;
            const response = yield fetch(`/wikia.php?controller=DiscussionThread&method=getThreads`, {
                headers: {
                    'X-Wiki-Id': productId,
                },
            });
            if (response.ok) {
                // eslint-disable-next-line
                const jsonBody = yield response.json();
                // eslint-disable-next-line
                const discussions = jsonBody._embedded.threads;
                const discussionThread = (_a = discussions
                    .filter((thread) => thread._embedded.contentImages.length > 0)
                    .sort(sortDescByLatestContributionTimestamp)[0]) !== null && _a !== void 0 ? _a : discussions.sort(sortDescByLatestContributionTimestamp)[0];
                return discussionThread;
            }
        }
        catch (err) {
            // eslint-disable-next-line
            log.error(err);
        }
        return null;
    });
}
